// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"2b585e03","330":"04cae29c","453":"428e3d2a","535":"64a95e30","588":"eb9e50a9","887":"fce76ff6","932":"edc68261"}[chunkId] + ".chunk.js";
};